<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data" prop="data" :rules="[$requiredChange]" key="data">
              <el-date-picker v-model="dados.data" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Status" prop="status" :rules="[$requiredChange]" key="status">
              <el-select v-model="dados.status">
                <el-option label="REALIZADA" value="realizada"></el-option>
                <el-option label="CANCELADA" value="cancelada"></el-option>
                <el-option label="PARCIAL" value="parcial"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Rota" prop="rota_id" :rules="[$requiredChange]" key="rota_id">
              <el-select v-model="dados.rota_id" placeholder="pesquisar..." filterable remote :remote-method="getRotaByFilter" :loading="loadingRota">
                <el-option v-for="r in rotas" :key="r.id" :label="r.nome" :value="r.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Motorista (opcional)" prop="motorista_id" key="motorista_id">
              <el-select v-model="dados.motorista_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getMotoristaByFilter" :loading="loadingMotorista">
                <el-option v-for="m in motoristas" :key="m.id" :label="m.nome" :value="m.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Veículo (opcional)" prop="veiculo_id" key="veiculo_id">
              <el-select v-model="dados.veiculo_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getVeiculoByFilter" :loading="loadingVeiculo">
                <el-option v-for="v in veiculos" :key="v.id" :label="v.placa" :value="v.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Observação" prop="observacao" key="observacao">
              <el-input type="textarea" :rows="3" v-model="dados.observacao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <c-panel title="Frequência do Transporte" titleIcon="fas fa-user-check">
          <div v-if="!dados.id" class="u-mt-10">
            <el-alert title="Salve a execução para liberar o registro de frequência." type="info" :closable="false"></el-alert>
          </div>

          <div v-else class="u-mt-10">
            <el-row :gutter="10" class="u-mb-10">
              <el-col :xs="24" :sm="12" :md="12">
                <el-button type="info" plain icon="el-icon-refresh" @click="loadFrequencia">RECARREGAR</el-button>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" class="u-text-right">
                <el-button type="primary" plain icon="el-icon-check" @click="saveFrequencia">SALVAR FREQUÊNCIA</el-button>
              </el-col>
            </el-row>

            <div class="container-table">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Aluno</th>
                    <th style="width: 160px;" class="u-text-center">Presente</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in frequencias" :key="row.aluno_id">
                    <td>{{ row.nome }}</td>
                    <td class="u-text-center">
                      <el-switch v-model="row.presente" active-text="SIM" inactive-text="NÃO"></el-switch>
                    </td>
                  </tr>
                  <tr v-if="!frequencias.length">
                    <td colspan="2">Nenhum aluno vinculado à rota.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </c-panel>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-execucao" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue')
  },
  data: () => ({
    edit: false,
    filtroInstituicao: { id: '', nome: '' },
    loadingRota: false,
    rotas: [],
    loadingMotorista: false,
    motoristas: [],
    loadingVeiculo: false,
    veiculos: [],
    frequencias: [],
    dados: {
      id: '',
      instituicao_id: '',
      rota_id: '',
      data: '',
      motorista_id: '',
      veiculo_id: '',
      status: 'realizada',
      observacao: ''
    }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    getRotaByFilter (query) {
      if (!query || query.length < 2) { this.rotas = []; return }
      this.loadingRota = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.rotas = JSON.parse(JSON.stringify(res.data)); this.loadingRota = false })
        .catch(e => { this.loadingRota = false; this.$store.commit('throwException', e) })
    },
    getMotoristaByFilter (query) {
      if (!query || query.length < 2) { this.motoristas = []; return }
      this.loadingMotorista = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/motorista/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.motoristas = JSON.parse(JSON.stringify(res.data)); this.loadingMotorista = false })
        .catch(e => { this.loadingMotorista = false; this.$store.commit('throwException', e) })
    },
    getVeiculoByFilter (query) {
      if (!query || query.length < 2) { this.veiculos = []; return }
      this.loadingVeiculo = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/veiculo/searchByPlaca`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.veiculos = JSON.parse(JSON.stringify(res.data)); this.loadingVeiculo = false })
        .catch(e => { this.loadingVeiculo = false; this.$store.commit('throwException', e) })
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/execucao/getById/` + id, this.$store.getters.getHeaderAuth)
      const data = JSON.parse(JSON.stringify(res.data))
      if (data && data.rota) { this.rotas = [{ id: data.rota.id, nome: data.rota.nome }]; delete data.rota }
      if (data && data.motorista) { this.motoristas = [{ id: data.motorista.id, nome: data.motorista.nome }]; delete data.motorista }
      if (data && data.veiculo) { this.veiculos = [{ id: data.veiculo.id, placa: data.veiculo.placa }]; delete data.veiculo }
      const freqs = data.frequencias || []
      delete data.frequencias
      this.dados = data
      // carregar frequência depois de carregar execução
      await this.loadFrequencia(freqs)
    },
    async loadFrequencia (freqsFromGetById = null) {
      if (!this.dados.id || !this.dados.rota_id) { this.frequencias = []; return }
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/aluno/getAllByRota/` + this.dados.rota_id, this.$store.getters.getHeaderAuth)
      const alunos = res.data || []

      const mapPresenca = {}
      const freqs = Array.isArray(freqsFromGetById) ? freqsFromGetById : []
      for (const f of freqs) {
        mapPresenca[f.aluno_id] = !!f.presente
      }

      this.frequencias = alunos.map(a => ({
        aluno_id: a.aluno_id,
        nome: (a.aluno && a.aluno.nome) ? a.aluno.nome : ('#' + a.aluno_id),
        presente: (typeof mapPresenca[a.aluno_id] !== 'undefined') ? mapPresenca[a.aluno_id] : false
      }))
    },
    async saveFrequencia () {
      if (!this.dados.id) return
      window.eventBus.$emit('loading', true)
      try {
        const payload = { itens: this.frequencias.map(r => ({ aluno_id: r.aluno_id, presente: r.presente })) }
        await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/frequencia/saveBatch/` + this.dados.id, payload, this.$store.getters.getHeaderAuth)
        window.eventBus.$emit('loading', false)
        window.eventBus.$emit('alert', { msg: 'Frequência salva com sucesso.', type: 'success' })
      } catch (e) {
        window.eventBus.$emit('loading', false)
        this.$store.commit('throwException', e)
      }
    },
    onSubmit () {
      document.getElementById("btn-execucao").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/execucao/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
          } else {
            const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/execucao/store`, this.dados, this.$store.getters.getHeaderAuth)
            if (res && res.data && res.data.id) {
              this.dados.id = res.data.id
              this.edit = true
            }
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitExecucao')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        }
      }
    }
  }
}
</script>

